import React from 'react';
import BotCortexDashboard from '../components/BotCortexDashboard.js';

function App() {
  return <BotCortexDashboard />;
}

export default App;
